import { format, isSameDay, isSameYear } from 'date-fns';
import { fr } from 'date-fns/locale';
import type { AiConversation } from '../types/aiChat.types';

const FALLBACK_AUTHOR = 'Un membre';
const SELF_AUTHOR = 'Vous';

export function getConversationAuthor(conversation: AiConversation, currentUserId: string | undefined): string {
  if (conversation.createdBy && conversation.createdBy === currentUserId) {
    return SELF_AUTHOR;
  }
  const name = [conversation.authorFirstName, conversation.authorLastName]
    .filter((part): part is string => Boolean(part?.trim()))
    .join(' ');
  return name || FALLBACK_AUTHOR;
}

/** "14:05" today, "12 oct." this year, "12 oct. 2025" before. */
export function formatConversationDate(isoDate: string, now: Date = new Date()): string {
  const date = new Date(isoDate);
  if (isSameDay(date, now)) {
    return format(date, 'HH:mm', { locale: fr });
  }
  if (isSameYear(date, now)) {
    return format(date, 'd MMM', { locale: fr });
  }
  return format(date, 'd MMM yyyy', { locale: fr });
}
